module.exports = __webpack_public_path__ + "img/23ne.fd1bfc65.svg";